import Vue from 'vue'
import Vuex from 'vuex'
import { dataService } from '../shared/dataService'
import axios from 'axios'
import ApiRoutes from '../api/ApiRoutes'

const Base = () => {
  let domain = window.location.hostname
  let indexOfDomainStart = domain.indexOf('.')
  if (domain !== 'localhost') {
    if (domain.split('.').length == 3) {
      return (
        window.location.protocol +
        '//cad-api' +
        domain.substring(indexOfDomainStart) +
        '/api/v1/'
      )
    }
    if (domain.split('.').length == 2) {
      return window.location.protocol + '//cad-api.' + domain + '/api/v1/'
    }
  } else {
    return process.env.VUE_APP_API_URL
  }
}

import {
  CLEAR_TOKEN,
  GET_APPS,
  REFRESH_LOGIN,
  SET_LOGON,
  GET_USER,
  REFRESH_USER,
  LOGOFF_USER,
  SET_ACCOUNT_COMPONENT,
  CHANGE_PASSWORD,
  SET_LOGO_PATH,
} from './constants'

Vue.use(Vuex)

const state = {
  applications: [],
  lightTheme: true,
  user: {
    agencyId: null,
    id: null,
    tenant_id: null,
    refreshExpires: null,
    token_expires: null,
  },
  userToAppMappings: [],
  currentAccountComponent: null,
  ready: false,
  loginError: '',
  logoFileName: null,
  logoPath: null,
  subdomain: '',
  tenant: null,
}

const actions = {
  async getTenant({ commit }) {
    let subdomain = ''
    const host = window.location.hostname
    if (host.includes('localhost')) {
      subdomain = 'dev'
    } else {
      subdomain = host.split('.')[0]
    }

    console.log('get tenant action')
    const { data } = await axios.get(`${Base()}tenants-subdomains/${subdomain}`)
    commit('setTenant', data)
  },

  async getAll({ commit }, path) {
    const { data } = await axios.get(`${Base()}${path}`)
    if (path.includes('?')) path = path.substring(0, path.indexOf('?'))
    if (path.includes('-')) path = path.replace(/-/g, '_')
    if (path.includes('roles')) path = 'roles'
    path += '_state'
    commit('setGlobal', { data, path })
  },

  async [SET_LOGON]({ commit, state }, credentials) {
    const logon = await dataService.logon(credentials, state.subdomain)
    commit(SET_LOGON, logon.user)
  },
  async [GET_APPS]({ commit }, apps) {
    const applications = await dataService.getApps()
    commit(GET_APPS, applications)
  },
  async [REFRESH_LOGIN]({ commit, dispatch }, refreshToken) {
    const login = await dataService.refreshLogon(refreshToken)
    if (login) {
      await commit(REFRESH_LOGIN, login.updated_token)
    } else {
      await dispatch(LOGOFF_USER)
    }
  },
  async [GET_USER]({ commit }, userId) {
    const user = await dataService.getUser(userId)
    commit(GET_USER, user)
  },
  async [LOGOFF_USER]({ commit }) {
    const logoff = await dataService.logoff()
    sessionStorage.removeItem('role_has_map')

    commit(LOGOFF_USER, logoff)
    commit(CLEAR_TOKEN)
  },
  async [CHANGE_PASSWORD]({ commit }, newPassword) {
    const id = document.cookie
      .split('; ')
      .find((row) => row.startsWith('id'))
      .split('=')[1]
    const password = await dataService.changePassword({
      id: id,
      newPassword: newPassword,
    })
  },
  loadExistingLogo({ commit, state }) {
    axios
      .get(`${ApiRoutes.Files.Logo}/logo?subdomain=${state.subdomain}`)
      .then((res) => {
        commit(SET_LOGO_PATH, res.request.responseURL)
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  setSubdomain({ commit }, subdomain) {
    commit('setSubdomain', subdomain)
  },
}

const mutations = {
  setTenant(state, data) {
    state.tenant = data
  },

  setGlobal(state, { path, data }) {
    Vue.set(state, path, data)
  },

  setLoginError: (state, error) => {
    state.loginError = error
  },
  clearLoginError: (state) => {
    state.loginError = ''
  },
  toggleReady: (state) => {
    Vue.set(state, 'ready', true)
  },
  [SET_ACCOUNT_COMPONENT](state, data) {
    state.currentAccountComponent = data
  },
  [SET_LOGON](state, user) {
    state.user = {
      admin: user.admin,
      agencyId: user.agencyId,
      token_expires: user.expires,
      id: user.id,
      tenant_id: user.tenantId,
      tenant_name: user.tenantName,
      refreshExpires: user.refreshExpires,
      fullName: user.fullName,
      logoffOtherUser: user.logoffOtherUser,
    }
    document.cookie = `workstation_id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `role_id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `admin=${state.user.admin};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `logoffOtherUser=${state.user.logoffOtherUser};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `sorn_accepted=true;domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `token_expires=${state.user.token_expires};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `refreshExpires=${state.user.refreshExpires};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `id=${state.user.id};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `agencyId=${state.user.agencyId};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `tenant_id=${state.user.tenant_id};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `tenant_name=${state.user.tenant_name};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    document.cookie = `fullName=${state.user.fullName};domain=${window.location.hostname
      };path=/;max-age=${state.user.refreshExpires * 60}`
    axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`
    axios.defaults.headers.post['Content-Type'] = 'application/json'
  },
  [CLEAR_TOKEN](state) {
    document.cookie = `id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `admin=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `role_id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `proQAPort=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `token_expires=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `tenant_id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `tenant_name=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `refreshExpires=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `agencyId=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `workstation_id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `sorn_accepted=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `fullName=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `logoffOtherUser=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `report_session=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `cad_session=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `reports_role_id=;domain=${window.location.hostname};path=/;max-age=-1`
    document.cookie = `reports_workstation_id=;domain=${window.location.hostname};path=/;max-age=-1`
    location.reload()
  },
  [GET_APPS](state, apps) {
    state.applications = apps
  },
  [REFRESH_USER](state) {
    const id = document.cookie.split('; ').find((row) => row.startsWith('id'))
    const agencyId = document.cookie
      .split('; ')
      .find((row) => row.startsWith('agencyId'))
    const tenant_id = document.cookie
      .split('; ')
      .find((row) => row.startsWith('tenant_id'))
    const token_expires = document.cookie
      .split('; ')
      .find((row) => row.startsWith('token_expires'))
    const refreshExpires = document.cookie
      .split('; ')
      .find((row) => row.startsWith('refreshExpires'))
    if (id) {
      Vue.set(state, 'user', {
        agencyId: agencyId.split('=')[1],
        token_expires: token_expires.split('=')[1],
        id: id.split('=')[1],
        tenant_id: tenant_id.split('=')[1],
        refreshExpires: refreshExpires.split('=')[1],
      })
    } else {
      state.ready = true
    }
  },
  [REFRESH_LOGIN](state, token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.post['Content-Type'] = 'application/json'
  },
  [GET_USER](state, user) {
    state.userToAppMappings = user.application_mappings
  },
  [LOGOFF_USER](state, logoff) {
    //
  },
  [CHANGE_PASSWORD](state, password) {
    //
  },
  [SET_LOGO_PATH](state, val) {
    state.logoPath = val
  },

  setSubdomain(state, val) {
    state.subdomain = val
  },
}

const setters = {}

const getters = {
  loggedIn(state) {
    return !!state.user
  },
}

const modules = {}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules,
  setters,
  getters,
})
